/**
 * @author mrdoob / http://mrdoob.com/
 */

import UI from './libs/ui'
var SoundTab = function ( editor ) {

	var signals = editor.signals;

	var container = new UI.Panel();
	container.setId( 'soundTab' );

	var selected = null;
	var values;

	function build() {

		container.clear();

		if ( selected === null ) return;

		values = {};

		// Time

		var row = new UI.Row();
		row.add(new UI.Text('Time').setWidth('45px'));
		container.add(row);

		var soundStart = new UI.Number(selected.start).setWidth('45px');
		soundStart.onChange(function () {

			selected.start = this.getValue();
			signals.animationModified.dispatch(selected);

		});
		row.add(soundStart);

		var soundEnd = new UI.Number(selected.end).setWidth('45px');
		soundEnd.onChange(function () {

			selected.end = this.getValue();
			signals.animationModified.dispatch(selected);

		});
		row.add(soundEnd);


		// Player
		var selectedAudio = editor.soundItems.find(soundItem => soundItem.audio.audioName === selected.name) || editor.soundItems[0]

		var row = new UI.Row();
		var player = new UI.Audio(selectedAudio.audio.audioURL)

		row.add(player)
		container.add(row);

		//Enter Sound Volume
		var row = new UI.Row();
		row.add(new UI.Text('Volume').setWidth('180px'));
		container.add(row);

		var voiceVolume = new UI.Number(selected.value || 0.5).setWidth('80px');
		voiceVolume.onChange(function (e) {

			let voiceVolume = this.getValue();
			selected.value = voiceVolume
			// signals.animationModified.dispatch(selected);

		});
		row.add(voiceVolume);

	}

	//

	// signals.editorCleared.add( function () {

	// 	selected = null;
	// 	build();

	// } );

	signals.animationSelected.add( function ( animation ) {
		if (animation && animation.type === 'Sound') {
			selected = animation;
			build();
		}
	} );

	signals.animationModified.add(function (animation) {
		if (animation && animation.type === 'Sound') {
			selected = animation;
			build();
		}
	});


	signals.effectCompiled.add( build );

	/*
	signals.timeChanged.add( function () {

		if ( selected !== null ) {

			for ( var key in values ) {

				values[ key ].setValue( selected.module.parameters[ key ].value );

			}

		}

	} );
	*/

	return container;

};

export default SoundTab


//////////////////
// WEBPACK FOOTER
// ./external_libs/frame.js/editor/js/SoundTab.js
// module id = null
// module chunks = 